export function draggable(el, binding, vnode) {
    // console.log(binding,vnode);
    let dom = binding.value
    let dragBox = el; //获取当前元素
    dragBox.onmousedown = e => {
        e.preventDefault()
        if (e.button != 0) {
            //只允许左键，
            return;
        }
        let firstTime, lastTime;
        firstTime = new Date().getTime();
        //算出鼠标相对元素的位置
        let disX = e.clientX - dragBox.offsetLeft;
        let disY = e.clientY - dragBox.offsetTop;
        document.onmousemove = e => {
            //若不设置宽高默认为窗口的宽高
            let domWidth = document.querySelector(dom)?.clientWidth || window.innerWidth
            let domHeight = document.querySelector(dom)?.clientHeight || window.innerHeight
            dragBox.style.cursor = 'move'
            //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
            let left = e.clientX - disX;
            let top = e.clientY - disY;
            if (left < 0) {
                left = 0;
            } else if (left > domWidth - dragBox.offsetWidth) {
                left = domWidth - dragBox.offsetWidth;
            }
            if (top < 0) {
                top = 0;
            } else if (top > domHeight - dragBox.offsetHeight) {
                top = domHeight - dragBox.offsetHeight;
            }
            //移动当前元素
            dragBox.style.left = left + "px";
            dragBox.style.top = top + "px";
        };
        document.onmouseup = e => {
            lastTime = new Date().getTime();
            dragBox.style.cursor = 'auto';
            //用于拖拽时会触发点击事件的问题
            if (lastTime - firstTime < 200) {
                //触发点击事件 
            } else {
                //触发拖拽事件 
            }
            //鼠标弹起来的时候不再移动
            document.onmousemove = null;
            //预防鼠标放上去的时候还会移动
            document.onmouseup = null;
        };
    };
}
